import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@flat-ui";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { DefaultPlatformSelector } from "@pages/settings/general-settings/default-platform-selector";
import { defaultProjectLaunchTargetSelector, fetchingSdbCompanyFlagsSelector } from "@store/sdb-company/sdb-company-selector";
import { fetchCompanyCommunicationSettings } from "@store/sdb-company/sdb-company-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { fetchingUserFlagsSelector } from "@store/user/user-selector";
import { useEffect, useMemo } from "react";

/** Custom hook that returns the default platform settings section */
export function useDefaultPlatformSection() {
  const $ = _c(7);
  const dispatch = useAppDispatch();
  const {
    isFetchingCompanyCommunicationSettings
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const {
    isFetchingCurrentUser
  } = useAppSelector(fetchingUserFlagsSelector);
  const {
    fetchSelectedCompanyContext
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const {
    canEditDefaultPlatform
  } = useHasUserValidRoleCompanyLevel();
  const projectLaunchSettings = useAppSelector(defaultProjectLaunchTargetSelector);
  let t0;
  bb0: {
    if (isFetchingCurrentUser || fetchSelectedCompanyContext === "pending" || !projectLaunchSettings.canOpenWebEditor) {
      t0 = false;
      break bb0;
    }
    t0 = canEditDefaultPlatform;
  }
  const shouldShowSection = t0;
  let t1;
  let t2;
  if ($[0] !== dispatch) {
    t1 = () => {
      dispatch(fetchCompanyCommunicationSettings());
    };
    t2 = [dispatch];
    $[0] = dispatch;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = !shouldShowSection;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [{
      shouldContentTakeFullWidth: true,
      content: <DefaultPlatformSelector />,
      customSkeleton: <Skeleton variant="rectangular" height="100%" width="100%" />
    }];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isFetchingCompanyCommunicationSettings || $[5] !== t3) {
    t5 = {
      title: "Default Application",
      subtitle: "Select which application you want to use as the default to open your projects.",
      isHidden: t3,
      isLoading: isFetchingCompanyCommunicationSettings,
      items: t4
    };
    $[4] = isFetchingCompanyCommunicationSettings;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}